import React from 'react';
import { arrayOf, bool, func, node, oneOfType, string } from 'prop-types';
import styles from './css/Help.css';

export function Help({ children, showHelp, title, toggle }) {
  return (
    <div className={showHelp ? styles.showHelp : styles.hideHelp}>
      {/* TODO: Probably should use a Crate X icon */}
      <div
        className={styles.closeHelp}
        data-test-id="toggle-help-button"
        onClick={toggle}
        role="button"
        tabIndex={0}
      >
        ×
      </div>
      <h4>{title}</h4>
      <ul>{children}</ul>
    </div>
  );
}

Help.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  showHelp: bool.isRequired,
  title: string.isRequired,
  toggle: func.isRequired,
};
